import { useEffect, useState } from 'react'

interface ImageContainerProps {
  height: number
  width?: number
  maxWidth?: number
  imageSource: string
  defaultImage: string
  altText: string
  objectFitting?: 'cover' | 'contain'
}

const ImageContainer: React.FC<ImageContainerProps> = ({
  height,
  width,
  maxWidth,
  imageSource,
  defaultImage,
  altText,
  objectFitting = 'contain'
}) => {
  return (
    <img
      src={Boolean(imageSource) ? imageSource : defaultImage}
      alt={altText}
      style={{
        float: 'left',
        height: height,
        width: width,
        maxWidth: maxWidth,
        backgroundColor: 'transparent',
        objectFit: objectFitting
      }}
    />
  )
}

export default ImageContainer
